import loadable from '@loadable/component';
import { LoaderSpin } from 'client/ui/loader/LoaderSpin';
import React from 'react';

/**
 * Lazy loading dei comuni ANPR
 */
export const PDNDForeignCountryLoadableInput = loadable(
  () =>
    import(
      /* webpackChunkName: "anpr_foreign_country" */ './PDNDForeignCountryInput'
    ),
  { fallback: <LoaderSpin full /> }
);
